import CliRateHeaderIndex from "@/components/billing/cli_rate/CliRateHeaderIndex.vue";
import CliRateHeaderAdd from "@/components/billing/cli_rate/CliRateHeaderAdd.vue";
import CliRateHeaderDetail from "@/components/billing/cli_rate/CliRateHeaderDetail.vue";
import CliRateHeaderEdit from "@/components/billing/cli_rate/CliRateHeaderEdit.vue";

let routesCliRateHeaderAccess= [
    {
        path: '',
        meta: {
          title: "List CLI Rate",
        },
        name: "CliRateHeaderIndex",
        component: CliRateHeaderIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create CLI Rate",
        },
        name: "CliRateHeaderAdd",
        component: CliRateHeaderAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail CLI Rate",
        },
        name: "CliRateHeaderDetail",
        component: CliRateHeaderDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit CLI Rate",
        },
        name: "CliRateHeaderEdit",
        component: CliRateHeaderEdit
    },
    
]

export default routesCliRateHeaderAccess
  